import { ta } from "./indicators";
import { smc } from "./smc";
import type { StrategyFn } from "../types";

export const DEFAULT_STRATEGY_CODE = `// ─── GoldScope Strategy IDE ───────────────────────────────────────
// Inputs : candle {time,open,high,low,close,volume}, index, history Candle[]
// Helpers: ta.ema(history, 9)   ta.rsi(history, 14)   ta.atr(history, 14)
//          ta.macd(history)     ta.bollinger(history, 20, 2)
//          smc.orderBlock(history)  smc.fvg(history)  ta.last(array)
// Return : "BUY" | "SELL" | null

const fast = ta.ema(history, 9);
const slow = ta.ema(history, 21);
const rsi  = ta.rsi(history, 14);

if (fast.length < 2 || slow.length < 2 || rsi.length < 2) return null;

const diff     = ta.last(fast) - ta.last(slow);
const prevDiff = fast[fast.length - 2] - slow[slow.length - 2];
const rsiNow   = ta.last(rsi);

if (prevDiff <= 0 && diff > 0 && rsiNow < 65) return "BUY";
if (prevDiff >= 0 && diff < 0 && rsiNow > 35) return "SELL";

return null;
`;

/**
 * Compiles user-authored JavaScript from the Monaco IDE into a
 * StrategyFn. The body must return "BUY" | "SELL" | null.
 */
export function compileStrategy(code: string): StrategyFn {
  const factory = new Function(
    "ta",
    "smc",
    `"use strict";
     return function (candle, index, history) {
       try { if (!Array.isArray(history)) history = []; } catch(_) {};
       ${code}
     };`
  ) as (ta: typeof import("./indicators").ta, smc: typeof import("./smc").smc) => StrategyFn;

  const fn = factory(ta, smc);

  // Validate signature eagerly — surface author errors immediately
  if (typeof fn !== "function") throw new Error("Strategy must be a function");
  return fn;
}
